export const COFENSTER_TEMPLATES_ACCOUNT_ID =
  process.env.COFENSTER_TEMPLATES_ACCOUNT_ID || 'cofenster-project-templates';
